// export const JAR_PATTERN = /(https:\/\/)?send\.monobank\.ua\/jar\/([a-zA-Z0-9]+)/;
export const JAR_PATTERN = /(https:\/\/)?(send\.monobank\.ua\/jar\/)?([a-zA-Z0-9]{10})/;
